import { render, staticRenderFns } from "./participant-type.vue?vue&type=template&id=8a3d04f6&"
import script from "./participant-type.vue?vue&type=script&lang=js&"
export * from "./participant-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports